










































import Vue from 'vue';
import axios from '@/plugins/axios';
import CtrlNormalTxt from '@/components/common/control/CtrlNormalTxt.vue';
import CtrlSearchCommonComponents from '@/components/common/control/CtrlSearchCommonComponents.vue';
import { API_SEARCH_JIGYOSHO, API_SEARCH_TOKUISAKI } from '@/constants/api';
import { SeikyusakiKb, UmuFlg } from '@/constants/constants';

export default Vue.extend({
  name: 'ListNohinsaki',
  components: {
    CtrlNormalTxt,
    CtrlSearchCommonComponents,
  },
  props: {
    jigyoshoCd: {
      type: Number,
      default: 0,
    },
    tokuisakiCd: {
      type: Number,
      default: 0,
    },
    mukoUmuFlg: {
      type: Number,
    },
  },
  data: () => ({
    headers: [
      {
        text: 'コード',
        sortable: true,
        value: 'nohinsakiCd',
        width: 100,
      },
      {
        text: '名称',
        sortable: true,
        value: 'nohinsakiMei',
        width: 510,
      },
    ],
    formatColName: 'nohinsakiCd',
    jigyoshoMei: '',
    tokuisakiMei: '',
    filterGroupKey: 0,
  }),
  methods: {
    getJigyoshoData() {
      axios
        .get(API_SEARCH_JIGYOSHO, {
          params: {
            jigyoshoCd: this.jigyoshoCd,
            mukoUmuFlg: UmuFlg.NASHI,
          },
        })
        .then((res) => {
          if (res.data.responseData && res.data.responseData.length > 0) {
            const { jigyoshoMei } = res.data.responseData[0];
            this.jigyoshoMei = jigyoshoMei;
          }
        });
    },
    getTokuisakiData() {
      axios
        .get(API_SEARCH_TOKUISAKI, {
          params: {
            jigyoshoCd: this.jigyoshoCd,
            tokuisakiCd: this.tokuisakiCd,
            seikyusakiKb: SeikyusakiKb.TOKUISAKI,
            mukoUmuFlg: UmuFlg.NASHI,
          },
        })
        .then((res) => {
          if (res.data.responseData && res.data.responseData.length > 0) {
            const { tokuisakiRyakuMei } = res.data.responseData[0];
            this.tokuisakiMei = tokuisakiRyakuMei;
          }
        });
    },
  },
  created() {
    this.getJigyoshoData();
    this.getTokuisakiData();
  },
});
